<template>
<div class="integral">
  <div class="top-bar white">
    <el-row :gutter="10">
      <el-col
        :xs="12" :sm="6" :md="6" :lg="6" :xl="6"
      >
        <div class="bar-inner">
          <div class="inner-top">{{$t('Summary_points')}}</div>
          <div class="inner-bottom">{{total}}</div>
        </div>
      </el-col>
      <el-col
        :xs="12" :sm="6" :md="6" :lg="6" :xl="6"
      >
        <div class="bar-inner">
          <div class="inner-top">{{$t('redeemed')}}</div>
          <div class="inner-bottom">{{change}}</div>
        </div>
      </el-col>
      <el-col
        :xs="12" :sm="6" :md="6" :lg="6" :xl="6"
      >
        <div class="bar-inner">
          <div class="inner-top">{{$t('expired')}}</div>
          <div class="inner-bottom">{{pass}}</div>
        </div>
      </el-col>
      <el-col
        :xs="12" :sm="6" :md="6" :lg="6" :xl="6"
      >
        <div class="bar-inner">
          <div class="inner-top">{{$t('Points_Available')}}</div>
          <div class="inner-bottom color-span">{{available}}</div>
        </div>
      </el-col>
    </el-row>
  </div>
  <div class="integral-outer-containe">
    <div class="nav-inner">
            <span
              class="inner-item fs16 font333 pointer"
              v-for="(item,index) of pswList"
              :key="index"
              @click="tabChange(item)"
              :class="{ on: item.routerName == $route.name }"
            >{{item.name}}</span>
    </div>
    <div class="view-outer integral-view-outer white pc-padding30-mobil-padding20">
      <router-view></router-view>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { initData } from '@/api/user'
export default {
  name: 'index',
  data() {
    let _this = this;
    return {
      total: '',
      change: '',
      pass: '',
      available: '',
      pswList: [
        { routerName: 'integralHome', name: _this.$t('Points_Details') },
        { routerName: 'integralRecord', name: _this.$t('Points_record') },
      ]
    };
  },
  created(){
    if(this.language == 'en_US'){
      this.$router.push({name: 'userCenterPerson'});
    }
    this.getTotal();
  },
  computed: {
    ...mapGetters(['language']),
  },
  methods: {
    tabChange(item) {
      this.$router.push({name: item.routerName})
    },
    getTotal(){
      let url =  'crm/reception/rewardPointInfo', params = {page: 0,size: 10}
      initData(url, params,true).then(res => {

        this.total = res.data.statistics.totalPoint;
        this.change = res.data.statistics.consumedPoint;
        this.pass = res.data.statistics.expiredPoint;
        this.available = res.data.statistics.availablePoint;
        // availablePoint: 0
        // consumedPoint: 0
        // expiredPoint: 0
        // totalPoint: 0
        // transPointAmount: 0
      })
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variable";
.integral {
  .top-bar {
    min-height: 100px;
    padding-top: 30px;
    padding-bottom: 30px;
    margin-bottom: 10px;
    .bar-inner {
      padding-left: 30px;
    }
    .color-span {
      color: $themeGreen;
    }
    .inner-top {
      color: #999999;
      padding-bottom: 10px;
    }
    .inner-bottom {
      font-weight: bold;
      font-size: 20px;
    }
  }
  .nav-inner {
    padding-top: 24px;
    padding-left: 30px;
    height: 60px;
    background: #FFFFFF;
    white-space: nowrap;
    // 边框颜色需要修改 todo
    border-bottom: 1px solid #E5E5E5;
    .inner-item {
      margin-right: 30px;
      display: inline-block;
      padding-bottom: 10px;

      &.on {
        color: $themeColor;
        border-bottom: 2px solid $themeColor;
      }
    }
  }
  .integral-view-outer {
    padding-bottom: 0;
  }
}
@media screen and (max-width: 768px) {
  .bar-inner {
    margin-bottom: 30px;
  }
}
</style>
